import React from "react";

interface ICertificateComponentProps {
    url: string;
    delay: string;
    name: string;
    visible?: boolean;
}

export const CertificateComponent: React.FC<ICertificateComponentProps> = (
    props: ICertificateComponentProps,
) => {
    const { url, delay, name, visible = true } = props;
    if (!visible) return null;

    return (
    <div
        className="col-12 col-md-4"
        data-aos="fade-up"
        data-aos-delay={delay}
        style={{
            display: "flex",
            justifyContent: "center",
        }}
    >
        <img
            loading="eager"
            src={url}
            alt={name}
            style={{
                width: "100%",
                maxWidth: "800px",
                height: "70%",
                objectFit: "contain",
            }}
        />
    </div>
);

};
